import { render, staticRenderFns } from "./DesignKpi.vue?vue&type=template&id=2a43784a&scoped=true"
import script from "./DesignKpi.vue?vue&type=script&lang=js"
export * from "./DesignKpi.vue?vue&type=script&lang=js"
import style0 from "./DesignKpi.vue?vue&type=style&index=0&id=2a43784a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a43784a",
  null
  
)

export default component.exports